export const SECTIONS = [
  { id: "intake", label: "Case Intake" },
  { id: "field_ops", label: "Field & Visit" },
  { id: "calling", label: "Calling & Client Coordination" },
  { id: "status", label: "Status & Updates" },
  { id: "closing", label: "Closing" },
  { id: "payments", label: "Payments & FE Payout" },
  { id: "misc", label: "Remarks & Misc" },
];

export const FIELDS = [
  { key: "sr_no", label: "Sr. No.", type: "number", section: "intake", auto: true },
  { key: "ac_ref_no", label: "AccuSearch Ref. No.", type: "text", section: "intake", auto: true },
  { key: "allocated_by", label: "Allocated By", type: "text", section: "intake" },
  { key: "client_spoc", label: "Client Spoc", type: "text", section: "intake" },
  { key: "received_date", label: "Received Date", type: "date", section: "intake" },
  { key: "received_time", label: "Received Time", type: "time", section: "intake" },
  { key: "client_name", label: "Client Name", type: "text", section: "intake" },
  { key: "company_name", label: "COMPANY NAME", type: "text", section: "intake" },
  { key: "ref_no", label: "REF No.", type: "text", section: "intake" },
  { key: "visit_type", label: "VISIT TYPE", type: "text", section: "intake" },
  { key: "candidate_name", label: "CANDIDATE/ CUSTOMER NAME", type: "text", section: "intake" },
  { key: "co", label: "C/O", type: "text", section: "intake" },
  { key: "father_company_name", label: "Father/ Company Name", type: "text", section: "intake" },
  { key: "address_type", label: "ADDRESS TYPE", type: "text", section: "intake" },
  { key: "visit_address", label: "VISIT ADDRESS", type: "textarea", section: "intake" },
  { key: "pincode", label: "PINCODE", type: "text", section: "intake" },
  { key: "contact_no", label: "CONTACT NO.", type: "text", section: "intake" },
  { key: "district", label: "DISTRICT", type: "text", section: "intake" },
  { key: "city_tq", label: "CITY (TQ)", type: "text", section: "intake" },
  { key: "client_visit_note", label: "Client Visit Note", type: "textarea", section: "intake" },
  { key: "old_days", label: "OLD DAYS", type: "number", section: "intake", computed: true },
  { key: "tat", label: "TAT", type: "text", section: "intake", computed: true },
  { key: "visit_date", label: "Date", type: "date", section: "field_ops" },
  { key: "c_code", label: "C Code", type: "text", section: "field_ops" },
  { key: "fe_coordinator", label: "FE Coordinator", type: "text", section: "field_ops" },
  { key: "visit_note", label: "Visit Note", type: "textarea", section: "field_ops" },
  { key: "fe_name", label: "FE Name", type: "text", section: "field_ops" },
  { key: "region", label: "REGION", type: "text", section: "field_ops" },
  { key: "client_spoc_2", label: "Client Spoc (Follow-up)", type: "text", section: "field_ops" },
  { key: "closing_by", label: "CLOSING BY", type: "text", section: "field_ops" },
  { key: "caller_name", label: "CALLER NAME", type: "text", section: "calling" },
  { key: "calling_remark", label: "Calling Remark", type: "textarea", section: "calling" },
  { key: "caller_code", label: "CALLER Code", type: "text", section: "calling" },
  { key: "client_links", label: "CLIENT LINKS", type: "textarea", section: "calling" },
  { key: "priority_case", label: "Priority Case", type: "select", section: "calling", options: ["Yes", "No"] },
  { key: "client_mail_updates", label: "CLIENT Mail Updates", type: "textarea", section: "calling" },
  { key: "abhi_c4p_status", label: "ABHI-C4P Status", type: "textarea", section: "calling" },
  { key: "sameer_updates", label: "SAMEER Updates", type: "textarea", section: "calling" },
  { key: "fe_case_confirmation_edc_status", label: "FE Case Confirmation & EDC Status", type: "textarea", section: "status" },
  { key: "client_cost_approvals", label: "CLIENT COST Approvals", type: "textarea", section: "status" },
  { key: "insuff_remark", label: "INSUFF Remark", type: "textarea", section: "status" },
  { key: "report_on_fe_case_status", label: "REPORT ON/ FE Case Status", type: "textarea", section: "status" },
  { key: "visit_remark", label: "VISIT REMARK", type: "textarea", section: "status" },
  { key: "closing_status", label: "CLOSING Status", type: "text", section: "closing" },
  { key: "case_status", label: "Case STATUS", type: "select", section: "closing",
    options: ["Open", "In Progress", "INSUFF", "Verification Done", "Report Submitted", "Closed", "On Hold", "Cancelled"] },
  { key: "closing_date", label: "DATE", type: "date", section: "closing" },
  { key: "closing_time", label: "Time", type: "time", section: "closing" },
  { key: "closed_by", label: "CLOSED BY", type: "text", section: "closing" },
  { key: "case_communication_details", label: "Case Communication Details", type: "textarea", section: "closing" },
  { key: "closing_status_points", label: "Closing Status Points", type: "textarea", section: "closing" },
  { key: "client_rate", label: "Client Rate", type: "number", section: "payments" },
  { key: "fe_ask_rate", label: "FE Ask Rate", type: "number", section: "payments" },
  { key: "fe_kms", label: "FE Kms", type: "number", section: "payments" },
  { key: "fe_final_rate", label: "FE Final Rate", type: "number", section: "payments" },
  { key: "fe_no", label: "FE No", type: "text", section: "payments" },
  { key: "paid_by", label: "Paid By", type: "select", section: "payments", options: ["PAY", "MONTH", "NA", "ABHI", "PUJA", "PRATAP"] },
  { key: "fe_paid_date", label: "FE Paid Date", type: "date", section: "payments" },
  { key: "mode_of_payment", label: "Mode of Payment", type: "select", section: "payments", options: ["Cash", "UPI", "Bank Transfer", "Cheque", "Other"] },
  { key: "fe_case_amt", label: "FE Case Amt", type: "number", section: "payments" },
  { key: "remark", label: "Remark", type: "textarea", section: "misc" },
  { key: "accusearch_comments", label: "AccuSearch Comments", type: "textarea", section: "misc" },
  { key: "vlookup", label: "VLOOKUP", type: "text", section: "misc" },
  { key: "fe_no_status", label: "FE NO STATUS", type: "text", section: "misc" },
];

export const TAT_COLORS = {
  "In TAT": "#10B981",
  "Due Today": "#F59E0B",
  "Out TAT": "#F97316",
  "Over TAT": "#EF4444",
  "Beyond TAT": "#991B1B",
};

export const ROLES = [
  { id: "master_admin", label: "Master Admin" },
  { id: "admin", label: "Admin" },
  { id: "manager", label: "Manager" },
  { id: "report_writer", label: "Report Writer" },
  { id: "client_coordinator", label: "Client Coordinator" },
  { id: "vendor_mgmt", label: "Vendor Mgmt" },
  { id: "team_leader", label: "Team Leader" },
  { id: "field_coordinator", label: "Field Coordinator" },
  { id: "caller", label: "Caller" },
  { id: "field_executive", label: "Field Executive" },
  { id: "client", label: "Client" },
];

export const ACTIONS = [
  { id: "create_case", label: "Create Case" },
  { id: "edit_case", label: "Edit Cases" },
  { id: "delete_case", label: "Delete Cases" },
  { id: "import_excel", label: "Excel Import" },
  { id: "manage_clients", label: "Manage Clients" },
  { id: "manage_fes", label: "Manage Field Executives" },
  { id: "manage_users", label: "Manage Users" },
  { id: "manage_permissions", label: "Manage Permissions" },
];

export const TABLE_COLUMNS = [
  "sr_no", "ac_ref_no", "received_date", "client_name", "company_name", "ref_no", "candidate_name",
  "visit_address", "pincode", "contact_no", "city_tq",
  "fe_name", "caller_name", "old_days", "tat", "priority_case", "case_status", "closing_status",
];

export function fieldByKey(key) {
  return FIELDS.find((f) => f.key === key);
}
